import { Component, OnInit } from '@angular/core';
import { AnouncementService } from '../../services/anouncement.service';
import { AnouncementItem } from '../../models/anouncementItem';

@Component({
    selector: 'app-anouncement-list',
    templateUrl: './anouncement-list.component.html',
    styleUrls: ['./anouncement-list.component.css']
})
export class AnouncementListComponent implements OnInit {
    listdata: Array<AnouncementItem>;

    /* pagination */
    currentPage: Number = 1;
    totalCount: Number = 0;
    pageSize: Number = 20;

    constructor(
        private service: AnouncementService
    ) { }

    ngOnInit() {
        this.update();
    }

    update() {
        this.service.getAnoucements(this.currentPage, this.pageSize).subscribe(res => {
            this.listdata = res.listdata;
            this.totalCount = res.totolCount;
        });
    }

    handlePageChange(event) {
        this.currentPage = event.currentPage;
        this.pageSize = event.pageSize;
        this.update();
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/anouncement-list/anouncement-list.component.ts